var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTourIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63288 0.431152H2.19139C1.24108 0.431152 0.470703 1.20153 0.470703 2.15184V10.7553C0.470703 11.7056 1.24108 12.4759 2.19138 12.4759H11.397C12.3473 12.4759 13.1177 11.7056 13.1177 10.7552V8.17454H11.9976V10.7552C11.9976 11.0869 11.7287 11.3558 11.397 11.3558H2.19138C1.85973 11.3558 1.59087 11.0869 1.59087 10.7553V2.15184C1.59087 1.82018 1.85973 1.55132 2.19139 1.55132H5.63288V0.431152Z",
    fill: "#5555FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0766 1.03801C13.079 0.728694 12.8301 0.47602 12.5208 0.473645L7.48024 0.434955C7.17092 0.432581 6.91825 0.681407 6.91587 0.990722C6.9135 1.30004 7.16232 1.55271 7.47164 1.55509L11.9522 1.58948L11.9178 6.07001C11.9154 6.37932 12.1642 6.632 12.4735 6.63437C12.7829 6.63674 13.0355 6.38792 13.0379 6.0786L13.0766 1.03801ZM6.88713 7.36342L12.9095 1.43278L12.1235 0.634645L6.10115 6.56529L6.88713 7.36342Z",
    fill: "#5555FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourIcon);
export default __webpack_public_path__ + "static/media/TourIcon.6c8a106433929a786476c5f0917114b9.svg";
export { ForwardRef as ReactComponent };